import { Component, OnInit } from '@angular/core';
import { Router, Params, ActivatedRoute } from "@angular/router";
import { Helpers } from '@app/helpers/helpers.class';

// Services
import { AuthService } from '@app/services/auth.service';

@Component({
    selector: 'app-report-time-per-cost-pool-admin-page',
    templateUrl: './report-time-per-cost-pool.component.html',
    styleUrls: ['./report-time-per-cost-pool.component.scss']
})

export class ReportTimePerCostPoolAdminComponent implements OnInit {
    employeeId: number;
    query: string;
    companyIds: number[];
    employmentTypeIds: number[];
    departmentIds: number[];
    staffingCompanyIds: number[];
    punchDateFrom: string;
    punchDateTo: string;
    active: boolean;
    page: number;

    constructor(private authService: AuthService,
        private activatedRoute: ActivatedRoute,
        private router: Router) { }

    ngOnInit(): void {
        this.employeeId = this.authService.getEmployeeId();
        const params: Params = Object.assign({}, this.activatedRoute.snapshot.queryParams);

        if (Helpers.isDefined(params['query'])) {
            this.query = params['query'];
        }

        if (Helpers.isDefined(params['companyIds'])) {
            this.companyIds = params['companyIds'];
        }

        if (Helpers.isDefined(params['employmentTypeIds'])) {
            this.employmentTypeIds = params['employmentTypeIds'];
        }

        if (Helpers.isDefined(params['departmentIds'])) {
            this.departmentIds = params['departmentIds'];
        }

        if (Helpers.isDefined(params['staffingCompanyIds'])) {
            this.departmentIds = params['staffingCompanyIds'];
        }

        if (Helpers.isDefined(params['punchDateFrom'])) {
            this.punchDateFrom = params['punchDateFrom'];
        }

        if (Helpers.isDefined(params['punchDateTo'])) {
            this.punchDateTo = params['punchDateTo'];
        }

        if (Helpers.isDefined(params['page'])) {
            this.page = params['page'];
        }
    }

    updateQueryParameters(filter: any): void {
        const params: Params = Object.assign({}, this.activatedRoute.snapshot.queryParams);
        params['companyIds'] = filter.companyIds.length > 0 ? filter.companyIds.join(',') : null;
        params['employmentTypeIds'] = filter.employmentTypeIds.length > 0 ? filter.employmentTypeIds.join(',') : null;
        params['departmentIds'] = filter.departmentIds.length > 0 ? filter.departmentIds.join(',') : null;
        params['staffingCompanyIds'] = filter.staffingCompanyIds.length > 0 ? filter.staffingCompanyIds.join(',') : null;
        params['punchDateFrom'] = filter.punchDateFrom.length > 0 ? filter.punchDateFrom : null;
        params['punchDateTo'] = filter.punchDateTo.length > 0 ? filter.punchDateTo : null;
        params['query'] = Helpers.isDefined(filter.query) && filter.query.length > 0 ?
            filter.query : null;
        params['page'] = filter.page;
        this.router.navigate([], { relativeTo: this.activatedRoute, queryParams: params });
    }
}
